export const AppActionType = {
    SHOW_LOADER: 'SHOW_LOADER',
    HIDE_LOADER: 'HIDE_LOADER',
    SHOW_HEADER: 'SHOW_HEADER',
    HIDE_HEADER: 'HIDE_HEADER',
    SHOW_FOOTER: 'SHOW_FOOTER',
    HIDE_FOOTER: 'HIDE_FOOTER',
    SET_MSISDN: 'SET_MSISDN'
};
